export default {
  // First page
  'collection.title': 'Manage collection',
  'collection.table.id': 'Collection code',
  'collection.table.name': 'Collection name',
  'collection.table.itemQuantity': 'Item quantity in collection',
  'collection.table.duration': 'Duration',
  'collection.table.status': 'Business status',

  'collection.filter.status': 'Business status',
  'collection.filter.bussiness-status.param':
    '{status,select, 1 {Available} 2 {Unavailable} 3 {Conclude} other {Undefined}}',
  'collection.filter.status--available': 'Available',
  'collection.filter.status--unavailable': 'Unavailable',
  'collection.filter.status--conclude': 'Conclude',

  'collection.delete.title': 'Delete collection',
  'collection.delete.content': 'Are you sure you want to delete this collection?',
  // Add/Edit page
  'updateCollection.title': 'Update collection',
  'addCollection.title': 'Add collection',
  'addCollection.id': 'Collection code',
  'addCollection.name': 'Collection name',
  'addCollection.duration': 'Duration',
  'addCollection.duration.message': 'Please select date',
  'addCollection.loopType': 'Applicable time frame',
  'addCollection.loopType--no': 'All day',
  'addCollection.loopType--yes': 'By time frame',
  'addCollection.repeat.message': 'Please select a time',
  'addCollection.repeat.button': 'Add time frame',
  'addCollection.loopType.overlapWarn': 'There is overlap between time frames',
  // Info page
  'collectionInfo.title': 'Collection information',
  'collectionInfo.id': 'Collection code',
  'collectionInfo.name': 'Collection name',
  'collectionInfo.duration': 'Duration',
  'collectionInfo.loopType': 'Applicable time frame',
  'collectionInfo.itemQuantity': 'Number of items',
  'collectionInfo.to': 'to',
};
